<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasFoodSupplier="true"
      :hasFoodStatusType="true"
      :hasFoodKind="true"
      :hasFood="true"
      :hasTradeStatusType="true"
      :hasCostType="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
    />
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      columns: [
        { name: "SupplierNumber" },
        { name: "SupplierName" },
        { name: "FoodNumber" },
        { name: "FoodName" },
        { name: "Barcode" },
        { name: "Qty" },
        { name: "OriginalPrice", headerText: "原價" },
        { name: "OriginalTotal" },
        { name: "DiscountPrice" },
        { name: "Total" },
        { name: "Cost" },
        { name: "TotalCost" },
        { name: "Unit" },
      ],
      items: [],
      pagination: {},
    };
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getSupplierFoodSaleOriginal(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getSupplierFoodSaleOriginal(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printSupplierFoodSaleOriginal(condition);
    },
    getItems(condition) {
      const vm = this;
      this.$api.reports.getSupplierFoodSaleOriginal(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
